var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v("Hint "+_vm._s(_vm.data.hintNo))]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.data.hintText)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }